import { useTimezone } from "@web-app/api";
import { TimelineDateTz } from "@web-app/components";
import { DateTimeTzProps } from "@web-app/types";

import ColumnedDateTimeTz from "./ColumnedDateTimeTz";
import DefaultDateTimeTz from "./DefaultDateTimeTz";
import ETATimeTz from "./ETATimeTz";
import FilterDateTimeTz from "./FilterDateTimeTz";
import FlatDateTimeTz from "./FlatTimeTz";
import PillDateTimeTz from "./PillDateTimeTz";
import TrackingPageTimelineTz from "./TrackingPageTimelineTz";
import TrackingPageTz from "./TrackingPagetz";

export default function DateTimeTz(props: DateTimeTzProps) {
  const { getTimezone, userTimezone, convertToTimezone } = useTimezone();
  const { timezone, presentation } = props;
  const orderTimezone = getTimezone(timezone);

  const tz1 = convertToTimezone(props.start, orderTimezone);
  const uTz1 = convertToTimezone(props.start, userTimezone);

  if (presentation === "flat") {
    if (!props.end) {
      return null;
    }

    const tz2 = convertToTimezone(props.end, orderTimezone);
    const uTz2 = convertToTimezone(props.end, userTimezone);

    return (
      <FlatDateTimeTz
        start={tz1}
        end={tz2}
        userStart={uTz1}
        userEnd={uTz2}
        timezone={orderTimezone}
        showIcon={props.showIcon}
      />
    );
  }

  if (presentation === "default") {
    return (
      <DefaultDateTimeTz
        date={tz1}
        userDate={uTz1}
        timezone={orderTimezone}
        includeSeconds={props.includeSeconds}
      />
    );
  }

  if (presentation === "columned") {
    return (
      <ColumnedDateTimeTz
        date={tz1}
        userDate={uTz1}
        timezone={orderTimezone}
        popupPosition={props.popupPosition ?? "top"}
      />
    );
  }

  if (presentation === "timeline") {
    return (
      <TimelineDateTz
        date={tz1}
        userDate={uTz1}
        timezone={orderTimezone}
        isTrackingPage={props.isTrackingPage}
        createdBy={props.createdBy}
      />
    );
  }

  if (presentation === "eta") {
    return <ETATimeTz date={tz1} userDate={uTz1} timezone={orderTimezone} />;
  }

  if (presentation === "trackingPage") {
    return (
      <TrackingPageTz
        date={tz1}
        userDate={uTz1}
        timezone={orderTimezone}
        popupPosition={props.popupPosition ?? "top"}
      />
    );
  }

  if (presentation === "trackingPageTimeline") {
    return <TrackingPageTimelineTz date={tz1} timezone={orderTimezone} />;
  }

  if (presentation === "filter") {
    if (!props.end) {
      return null;
    }

    return (
      <FilterDateTimeTz
        start={props.start}
        end={props.end}
        timezone={userTimezone}
        isDateRange={props.isDateRange}
      />
    );
  }

  if (presentation === "pill") {
    if (!props.end) {
      return null;
    }

    return (
      <PillDateTimeTz
        start={props.start}
        end={props.end}
        timezone={userTimezone}
        isDateRange={props.isDateRange}
      />
    );
  }

  return <></>;
}
